import React from 'react';
import { useQueries } from 'react-query';
import API from '@wheeebo/polaris-api';
import Map from './Map';
import useMap from './useMap';
function MissionMap({ apiKey, missionId, hideAllUIs }) {
    const { setBounds } = useMap();
    const flightPathOptions = { missionId, preload: ['waypoints'] };
    const [{ data: geoFences }, { data: flightPaths }, { data: safePorts }] = useQueries([
        {
            queryKey: API.GeoFences.listKey(missionId, {}),
            queryFn: () => API.GeoFences.list(missionId, {}),
        },
        {
            queryKey: API.FlightPaths.listKey(flightPathOptions),
            queryFn: () => API.FlightPaths.list(flightPathOptions),
        },
        {
            queryKey: API.SafePorts.listKey(missionId, {}),
            queryFn: () => API.SafePorts.list(missionId, {}),
        },
    ]);
    React.useEffect(() => {
        const coords = flightPaths?.items.flatMap((e) => e.waypoints?.map((e) => e.location).filter((e) => !!e));
        if (coords) {
            setTimeout(() => setBounds?.(coords), 500);
        }
    }, [flightPaths?.items, setBounds]);
    return (React.createElement(Map, { apiKey: apiKey, geoFences: geoFences?.items, safePorts: safePorts?.items, flightPaths: flightPaths?.items, hideAllUIs: hideAllUIs, draggable: true, locked: true }));
}
export default React.memo(MissionMap);
